export const converPrice = (price: number) => {
  const _price = Math.round((Math.round(price * 100)/100));
  return _price.toLocaleString("en-US");
};
